module.exports = __webpack_public_path__ + "static/media/bridge.b3191c10.svg";